import { render, staticRenderFns } from "./broadcast.vue?vue&type=template&id=5a8f66d5&scoped=true"
import script from "./broadcast.vue?vue&type=script&lang=js"
export * from "./broadcast.vue?vue&type=script&lang=js"
import style0 from "./broadcast.vue?vue&type=style&index=0&id=5a8f66d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8f66d5",
  null
  
)

export default component.exports